var map = {
	"./de-DE/text_select-hero.png": "f015",
	"./en-GB/text_select-hero.png": "b070",
	"./en-US/text_select-hero.png": "19e5",
	"./es-ES/text_select-hero.png": "5a3c",
	"./es-MX/text_select-hero.png": "7ff6",
	"./fr-CA/text_select-hero.png": "4591",
	"./fr-FR/text_select-hero.png": "e569",
	"./it-IT/text_select-hero.png": "6dbc",
	"./ja-JP/text_select-hero.png": "fe34",
	"./pt-BR/text_select-hero.png": "c46e",
	"./zh-TW/text_select-hero.png": "6bde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e2a";